import type { FaireProductEntity } from "../../entity_types/product";

export const p_tzcpk9md2u: FaireProductEntity = {
  token: "p_tzcpk9md2u",
  type: "product",
  name: "Mountain: Novelty Mahjong Playing Card (Set of 4)",
  brandToken: "b_m2upumjee3",
  brandName: "Mahjong & Magnolias",
  imageUrl:
    "https://cdn.faire.com/fastly/6e66d008ba2448033ca2718feb84ec95a2d0e4ca1f4db3b678a4e6eb0e2b9b18.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/86655fd0b5f7691070245ab5a9de4a8a71645d39f527b6faad871261f364601f.jpeg",
    "https://cdn.faire.com/fastly/e36ca194bba811e09c70a78028dc48f4d5edd2d94e92e76a732fe4b7e513a456.jpeg",
  ],
  priceDollars: 24,
  description:
    "A delightful alternative to the standard National Mahjong League card.  Our cards use the same tiles and the same rules as American Mahjong but a unique legend. The cards have a wordplay twist and use tiles to spell words like Fire Pit, Blanket and Skiing. \n\nThese matte laminated cards are sold in sets of four so everyone in your group can play.\n\nLearn more by watching our video below.",
  tags: [],
  msrpDollars: 48,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:49:51.693Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
